import {Component} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

/**
 * Explains the two payout-rule settings, with worked examples.
 *
 * It lives behind an info button rather than on the page because the page needs one plain line per section
 * and this needs three examples to be clear. The examples are the real organization shapes — that is what
 * makes "the payment varies per game" concrete rather than abstract.
 */
@Component({
  selector: 'app-payout-rules-help',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './payout-rules-help.component.html',
  styleUrls: ['./payout-rules-help.component.scss']
})
export class PayoutRulesHelpComponent {
}
